import { Divider as AntDivider } from 'antd'
import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

const Divider = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn('flex w-full items-center justify-center', className)}
      {...props}
    >
      <AntDivider className="border-gray-800/50" />
    </div>
  )
}

export default Divider
